import React from "react";
import "./Style.css";
import Container from "react-bootstrap/Container";
import CloudCheckIcon from "mdi-react/CloudCheckIcon";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";

function formatPhone($phone) {
    return "tel:" + $phone;
}

function formatMail($mail) {
    return "mailto:" + $mail;
}

const CheckIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15px"
        height="15px"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="feather feather-check-circle"
    >
        <polyline points="13 17 18 12 13 7" stroke="#7061ff"></polyline>
        <polyline points="6 17 11 12 6 7" stroke="#7061ff"></polyline>
    </svg>
);

function Cloudconsult2() {
    return (
        <div class="cloud-contact">
            <div class="cloud-cs-contain">
                <div class="cloud-contact-header">
                    <p class="typo-21-sm typo-medium typo-white">Private Kubernetes 구축 • 운영 컨설팅</p>
                </div>
                <div class="cloud-contact-intro">
                    <div class="cloud-contact-intro-text typo-14 purple-primary">
                        <div className="cloud-item-li">
                            <div className="cloud-item-icon">
                                <CheckIcon />
                            </div>
                            <div className="cloud-item-text">
                                <p class="typo-14">컨터이너를 이용한 컴퓨팅 자원 사용으로 비용절감</p>
                            </div>
                        </div>
                        <div className="cloud-item-li">
                            <div className="cloud-item-icon">
                                <CheckIcon />
                            </div>
                            <div className="cloud-item-text">
                                <p class="typo-14">마이크로서비스 도입을 위한 개발과 시스템구성 상담</p>
                            </div>
                        </div>
                        <div className="cloud-item-li">
                            <div className="cloud-item-icon">
                                <CheckIcon />
                            </div>
                            <div className="cloud-item-text">
                                <p class="typo-14">적은 비용으로 자체 독립 클라우드 구축및 운영지원</p>
                            </div>
                        </div>
                    </div>
                    <div class="cloud-contact-intro-btn typo-14 purple-primary">
                        <a className="url-btn" href="https://hanbiro.com/#/server-signup-ko">
                            <button className="cloud-buton">
                                <p class="typo-14 typo-medium purple-primary">서비스 신청</p>
                            </button>
                        </a>
                    </div>
                </div>
            </div>
            <div className="cloud-cs-contact">
                <div className="cloud-cs-contact-box">
                    <div className="cloud-contact-block">
                        <div className="cloud-contact-item">
                            <div className="cloud-contact-item1">
                                <div className="cloud-contact-text">
                                    <p class="typo-14 typo-medium">신윤호 부장</p>
                                </div>
                                <div className="cloud-contact-number">
                                    <div className="cloud-contact-icon">
                                        <LocalPhoneIcon sx={{ fontSize: 12 }} />
                                    </div>
                                    <div className="phoneline" href={formatPhone()}>
                                        <p class="typo-14 typo-black">&nbsp;{"070-4804-9651"}</p>
                                    </div>
                                    <span>&nbsp;</span>
                                    <span class="show-mail">
                                        <br></br>
                                    </span>
                                    <div className="cloud-contact-icon">
                                        <MailOutlineIcon sx={{ fontSize: 12 }} />
                                    </div>
                                    <div className="mailline" href={formatMail()}>
                                        <p class="typo-14 typo-black">&nbsp;{"cloud@hanbiro.com"}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="cloud-contact-item">
                            <div className="cloud-contact-item1">
                                <div className="cloud-contact-text">
                                    <p class="typo-14 typo-medium">김정윤 부장</p>
                                </div>
                                <div className="cloud-contact-number">
                                    <div className="cloud-contact-icon">
                                        <LocalPhoneIcon sx={{ fontSize: 12 }} />
                                    </div>
                                    <div className="phoneline" href={formatPhone()}>
                                        <p class="typo-14 typo-black">&nbsp;{"070-4804-9668"}</p>
                                    </div>
                                    <span>&nbsp;</span>
                                    <span class="show-mail">
                                        <br></br>
                                    </span>
                                    <div className="cloud-contact-icon">
                                        <MailOutlineIcon sx={{ fontSize: 12 }} />
                                    </div>
                                    <div className="mailline" href={formatMail()}>
                                        <p class="typo-14 typo-black">&nbsp;{"cloud@hanbiro.com"}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cloud-contact-block">
                        <div className="cloud-contact-item">
                            <div className="cloud-contact-item1">
                                <div className="cloud-contact-text">
                                    <p class="typo-14 typo-medium">신경섭 부장</p>
                                </div>
                                <div className="cloud-contact-number">
                                    <div className="cloud-contact-icon">
                                        <LocalPhoneIcon sx={{ fontSize: 12 }} />
                                    </div>
                                    <div className="phoneline" href={formatPhone()}>
                                        <p class="typo-14 typo-black">&nbsp;{"070-4804-9664"}</p>
                                    </div>
                                    <span>&nbsp;</span>
                                    <span class="show-mail">
                                        <br></br>
                                    </span>
                                    <div className="cloud-contact-icon">
                                        <MailOutlineIcon sx={{ fontSize: 12 }} />
                                    </div>
                                    <div className="mailline" href={formatMail()}>
                                        <p class="typo-14 typo-black">&nbsp;{"cloud@hanbiro.com"}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="cloud-contact-item">
                            <div className="cloud-contact-item1">
                                <div className="cloud-contact-text">
                                    <p class="typo-14 typo-medium">신상우 부장</p>
                                </div>
                                <div className="cloud-contact-number">
                                    <div className="cloud-contact-icon">
                                        <LocalPhoneIcon sx={{ fontSize: 12 }} />
                                    </div>
                                    <div className="phoneline" href={formatPhone()}>
                                        <p class="typo-14 typo-black">&nbsp;{"070-4804-9662"}</p>
                                    </div>
                                    <span>&nbsp;</span>
                                    <span class="show-mail">
                                        <br></br>
                                    </span>
                                    <div className="cloud-contact-icon">
                                        <MailOutlineIcon sx={{ fontSize: 12 }} />
                                    </div>
                                    <div className="mailline" href={formatMail()}>
                                        <p class="typo-14 typo-black">&nbsp;{"cloud@hanbiro.com"}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cloud-contact-block">
                        <div className="cloud-contact-item">
                            <div className="cloud-contact-item1">
                                <div className="cloud-contact-text">
                                    <p class="typo-14 typo-medium">조성학 이사 (해외)</p>
                                </div>
                                <div className="cloud-contact-number">
                                    <div className="cloud-contact-icon">
                                        <LocalPhoneIcon sx={{ fontSize: 12 }} />
                                    </div>
                                    <div className="phoneline" href={formatPhone()}>
                                        <p class="typo-14 typo-black">&nbsp;{"+84 909 284 160"}</p>
                                    </div>
                                    <span>&nbsp;</span>
                                    <span class="show-mail">
                                        <br></br>
                                    </span>
                                    <div className="cloud-contact-icon">
                                        <MailOutlineIcon sx={{ fontSize: 12 }} />
                                    </div>
                                    <div className="mailline" href={formatMail()}>
                                        <p class="typo-14 typo-black">&nbsp;{"cloud@hanbiro.com"}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Cloudconsult2;
